import * as THREE from 'three'
import Experience from "../Experience"

export default class Walls {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.resource = this.resources.items.wallsModel

        this.setGeometry()
        this.setTextures()
        this.setMaterial()
        this.setMesh()
    }

    setGeometry() {
        // console.log(this.resource.scene)
        this.geometry = this.resource.scene.children[0].geometry
    }

    setTextures() {
        this.textures = {}
        this.textures.color = this.resources.items.wallsTextureSimple
        this.textures.color.colorSpace = THREE.SRGBColorSpace
        // this.textures.color.repeat.set(1, 1)
        this.textures.color.wrapS = THREE.RepeatWrapping
        this.textures.color.wrapT = THREE.RepeatWrapping
        this.textures.color.repeat.y = -1;


        // this.textures.normal = this.resources.items.grassNormalTexture
        // this.textures.normal.repeat.set(1.5, 1.5)
        // this.textures.normal.wrapS = THREE.RepeatWrapping
        // this.textures.normal.wrapT = THREE.RepeatWrapping
    }

    setMaterial() {
        // This doesn't do anything
        this.material = new THREE.MeshBasicMaterial({
            map: this.textures.color,
            // normalMap: this.textures.normal,
        })
    }

    setMesh() {
        this.model = this.resource.scene
        this.model.receiveShadow = false
        this.model.castShadow = false
        // this.model.scale.set(1.3, 1.3, 1.3)
        this.scene.add(this.model)

        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.material = this.material;

                child.receiveShadow = false;
                child.castShadow = false;
            }
        })


        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                // child.material.color = THREE.Color('0xffffff')

                child.receiveShadow = false;
                child.castShadow = false;
                // child.material.side = THREE.FrontSide
                // child.material = new THREE.MeshBasicMaterial({
                //     // map: this.textures.color,
                //     // normalMap: this.textures.normal,
                // })
                // child.material.smoothShading = true
            }
        })
    }
}